import React, { useState, useEffect, useLayoutEffect, useCallback } from 'react'
import styles from './scroll-indicators.scss'
import AnimateOnHover from 'jd-library/AnimateOnHover';

const ScrollIndicators = React.memo((props) => {
	const {
		scrollContainerRef
	} = props;
	const [showLeft, toggleLeft] = useState(false);
	const [showRight, toggleRight] = useState(true);
	useEffect(() => {
		const mediaRowHolder = scrollContainerRef.current;
		if(mediaRowHolder.scrollWidth <= mediaRowHolder.clientWidth){
			toggleRight(false);
		}
		mediaRowHolder.onscroll = (e) => {
			let showLeftIndicator = false;
			let showRightIndicator = true;
			if(mediaRowHolder.scrollLeft > 0){
				//show left
				showLeftIndicator = true;
			}
			let nearlyEqual= (mediaRowHolder.scrollWidth - mediaRowHolder.clientWidth) -mediaRowHolder.scrollLeft
			if(mediaRowHolder.scrollLeft === (mediaRowHolder.scrollWidth - mediaRowHolder.clientWidth) || nearlyEqual<=3){
				//hide right
				showRightIndicator = false;
			}
			toggleLeft(showLeftIndicator);
			toggleRight(showRightIndicator);
		}
	}, [scrollContainerRef, props.mediaLength])
	const onClick = useCallback((e, variant) => {
		const scrollingEle = scrollContainerRef.current;
		let curScrollPos = scrollingEle.scrollLeft;
		let scrollWidth = scrollingEle.scrollWidth;
		let clientWidth = scrollingEle.clientWidth;
		let changeInScroll = 250;
		let newScrollPos = curScrollPos - changeInScroll;
		if(variant === 'left'){
			newScrollPos = Math.max(0, newScrollPos)
		} else{
			newScrollPos = curScrollPos + changeInScroll;
			newScrollPos = Math.min(scrollWidth - clientWidth, newScrollPos);
		}
		if(curScrollPos != newScrollPos){
			scrollingEle.scrollTo({left: newScrollPos, behavior: 'smooth'})
		}
	}, [scrollContainerRef])

	if(!scrollContainerRef){
		return null
	}
	return (
		<>
			<Indicator
				{...props}
				active={showLeft}
				variant='left'
				onClick={onClick}
			/>
			<Indicator
				{...props}
				active={showRight}
				variant='right'
				onClick={onClick}
			/>
		</>
	)
})

const Indicator = React.memo(({ variant, active, onClick }) => {
	return (
		<div
			className={`${styles['indicator']} ${styles[variant]} ${
				styles[active ? 'active' : '']
			}`}
			onClick={(e) => onClick(e, variant)}
		>
			<AnimateOnHover
				className={`${
					variant === 'left'
						? 'icon-HDRback'
						: 'icon-Next'
				} ${styles['indicator-icon-holder']}`}
			/>
		</div>
	)
})

ScrollIndicators.displayName = 'ScrollingIndicators'

export default ScrollIndicators